import React, { useCallback } from 'react'
import dayjs from 'dayjs'
import MediaList from 'components/partials/MediaList'
import MediaImage from 'components/partials/MediaImage'
import MediaContent from 'components/partials/MediaContent'
import IconArrowRight from 'components/partials/IconArrowRight'
import Description from 'components/partials/Description'
import MetaContainer from 'components/partials/MetaContainer'
import Breadcrumb from 'components/Breadcrumb'
import { Link } from 'components/Link'
import Label from 'components/Label'
import ViewModeContext from 'contexts/ViewModeContext'
import useClickLogger from 'api/ClickLogger'

function NewsTemplate({ ...doc }) {
  return (
    <ViewModeContext.Consumer>
      {context => context.isTable ? (
        <NewsTable {...doc} />
      ) : (
        <NewsTeaser {...doc} />
      )}
    </ViewModeContext.Consumer>
  )
}

export default NewsTemplate

function NewsTable({
  image_url,
  title,
  _click,
  preamble_cutoff,
  published,
  news_areas,
  url,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <tr onClick={trackResultClick} style={{ cursor: 'pointer' }}>
      <td>
        <div className='media'>
          {image_url && <MediaImage src={image_url} />}
          <MediaContent>
            <Link href={url}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
              <IconArrowRight />
            </Link>
            <Description text={preamble_cutoff} modifierClasses="u-mt-25" />
          </MediaContent>
        </div>
      </td>
      <td>
        <Description text={published && dayjs(published).format('L')} />
      </td>
      <td>
        <Description text={[].concat(news_areas).join(', ')} />
      </td>
    </tr>
  )
}

function NewsTeaser({
  title,
  preamble_cutoff,
  published,
  url,
  _click,
  image_url,
  news_areas,
  __breadcrumb__,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <MediaList onClick={trackResultClick}>
      {image_url && <MediaImage src={image_url} />}
      <MediaContent>
        <Link href={url}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
          <IconArrowRight />
        </Link>
        <MetaContainer>
          <Label
            modifierClasses='u-font-weight-700 u-mt-25 u-mr-100'
            text={published && dayjs(published).format('D MMMM YYYY')}
          />
          <Label
            modifierClasses='u-font-weight-700 u-mt-25'
            text={[].concat(news_areas).join(', ')}
          />
        </MetaContainer>
        <Description text={preamble_cutoff} modifierClasses="u-mt-25" />
        <Breadcrumb links={__breadcrumb__} modifierClasses="u-mt-50" disabled />
      </MediaContent>
    </MediaList>
  )
}
